import { Component, inject, signal, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ScraperApiService } from '../../../../core/api/scraper-api.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-scraper-alert-indicator',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div
      class="llm-dot flex items-center gap-1.5 px-2 py-1 rounded-lg hover:bg-[var(--color-surface-hover)] transition-colors cursor-pointer"
      (click)="navigateToDashboard()">
      @if (alerting()) {
        <span class="relative w-2 h-2 rounded-full bg-red-500 animate-pulse"></span>
        <span class="text-[10px] font-medium text-red-400">{{ alertCount() }}</span>
      } @else {
        <span class="relative w-2 h-2 rounded-full bg-zinc-600"></span>
        <span class="text-[10px] font-medium text-zinc-400">0</span>
      }
    </div>
  `,
  styles: []
})
export class ScraperAlertIndicatorComponent implements OnInit, OnDestroy {
  private api      = inject(ScraperApiService);
  private router   = inject(Router);

  alerting       = signal(false);
  alertCount     = signal(0);

  alertPollId: ReturnType<typeof setInterval> | null = null;

  ngOnInit(): void {
    this.startPoll();
  }

  ngOnDestroy(): void {
    this.stopPoll();
  }

  private startPoll(): void {
    this.alertPollId = setInterval(() => this.loadHealth(), 15_000);
  }

  private stopPoll(): void {
    if (this.alertPollId !== null) clearInterval(this.alertPollId);
    this.alertPollId = null;
  }

  private loadHealth(): void {
    this.api.getScraperHealth().subscribe({
      next: ({ overall, platforms }) => {
        this.alerting.set(overall.alerting);
        this.alertCount.set(platforms?.filter(p => p.alerting).length ?? 0);
      },
    });
  }

  navigateToDashboard(): void {
    this.router.navigate(['/dashboard']);
  }
}